import React from "react";
import {connect} from "react-redux";
import {Form, message, Table} from "antd";
import {getLoanUsersList} from "../../reducers/usersReducer";
import ErrorMessageContent from "../../components/ErrorMessageContent/ErrorMessageContent";
import {Link} from "react-router-dom";

class TableContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalVisible: false,
            editing_user_data: {},
            isFullNameDisabled: true,
            isEmailDisabled: true,
            isMarketDisabled: true,
            isPartnerShown: false,
            firstNameMaxLength: null,
            actionType: 0
        }

    this.columns = [];
    // if user is not admin, there is no need to show access column
    // access column index might be changed in a future, that's why we delete that element with index
    if (this.props.user_type != 4) {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i]["dataIndex"] === "access") {
          this.columns.splice(i,1);
          break;
        }
      }
    }
  }

    compareByAlphabet = (a, b) => {
        if (a > b) {
            return -1;
        }
        if (a < b) {
            return 1;
        }
        return 0;
    }

    handlePageOnChange = (page_number) => {
        this.props.dispatch(getLoanUsersList(page_number, {}));
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.user_edited !== this.props.user_edited && this.props.user_edited) {
            if (this.state.actionType != 5) {
                message.success("Օգտատիրոջ տվյալները հաջողությամբ փոփոխվեցին");
            } else {
                message.success("Գաղտնաբառի վերաբերյալ տվյալներն ուղարկվել են օգտատիրոջ էլեկտրոնային հասցեին");
            }
            this.setState({
                modalVisible: false,
                editing_user_data: {},
                isFullNameDisabled: true,
                isEmailDisabled: true,
                isMarketDisabled: true,
                isPartnerShown: false,
                actionType: 0
            })
            this.props.form.resetFields();
        }

        if (this.props.error_message.type === "get_shop_by_partner_id" && (prevProps.error_message.message !== this.props.error_message.message && this.props.error_message.message !== "")) {
            message.error(<ErrorMessageContent text={this.props.error_message.message}/>, 5);
        }
    }

    render() {
        const users_list = this.props.users_list.LoanUsers;
        const data = [];

        if (users_list !== undefined) {
            users_list.map((element) => {
                data.push({
                    "fullname": `${element.firstName} ${element.lastName}`,
                    "login": element.login,
                    "access": element.permission,
                    "status": element.quality ? "Գործող" : "Ապակտիվացված",
                    "isBlocked": element.isBlocked ? "Այո" : "Ոչ",
                    // "password": element.password != null ? element.password : "-",
                    "edit": element,
                    "shopName": element.shopName,
                    "companyName": element.companyName
                })
            })
        }

        //Total = mi eji objectneri qanak * te qani ej ka @ndhanrapes
        const paginationParams = {
            pageSize: data.length,
            total: data.length * this.props.users_list.PageCount,
            onChange: this.handlePageOnChange,
            hideOnSinglePage: true,
            current: this.props.users_list_filter.pageNumber,
        };
        this.columns =this.props.user_type === 4 ? [
            {
                title: 'Անուն Ազգանուն',
                dataIndex: 'fullname',
                render: text => <b style={{fontSize: 18}}>{text}</b>,
                sorter: (a,b) => this.compareByAlphabet(a.fullname, b.fullname),
            },
            {
                title: 'Մուտքանուն',
                dataIndex: 'login',
                sorter: (a,b) => this.compareByAlphabet(a.login, b.login),
            },
            {
                title: 'Հասանելիություն',
                dataIndex: 'access',
                sorter: (a,b) => this.compareByAlphabet(a.access, b.access),
            },
            {
                title: 'Կազմակերպություն ',
                dataIndex: 'companyName',
                sorter: (a,b) => this.compareByAlphabet(a.companyName, b.companyName),
            },
            {
                title: 'Խանութ',
                dataIndex: 'shopName',
                sorter: (a,b) => this.compareByAlphabet(a.shopName, b.shopName),
            },
            {
                title: 'Կարգավիճակ',
                dataIndex: 'status',
                sorter: (a,b) => this.compareByAlphabet(a.status, b.status),
            },
            {
                title: 'Բլոկավորված',
                dataIndex: 'isBlocked',
            },
            /*{
              title: 'Նախ. գաղտնաբառ',
              dataIndex: 'password',
            },*/
            {
                title: '',
                dataIndex: 'edit',
                render: editing_user_data => (
                    <Link to={{
                        pathname: `/users/edit-user/${this.props.user_type}`,
                        state: { userData: editing_user_data } // This "carries" the full object to the next page
                    }}>
                        <button
                            type="button"
                            className="cust_btn color-green"
                        >
                            Խմբագրել
                        </button>
                    </Link>

                )
            }
        ] : [
            {
                title: 'Անուն Ազգանուն',
                dataIndex: 'fullname',
                render: text => <b style={{fontSize: 18}}>{text}</b>,
                sorter: (a,b) => this.compareByAlphabet(a.fullname, b.fullname),
            },
            {
                title: 'Մուտքանուն',
                dataIndex: 'login',
                sorter: (a,b) => this.compareByAlphabet(a.login, b.login),
            },
            {
                title: 'Հասանելիություն',
                dataIndex: 'access',
                sorter: (a,b) => this.compareByAlphabet(a.access, b.access),
            },
            {
                title: 'Կարգավիճակ',
                dataIndex: 'status',
                sorter: (a,b) => this.compareByAlphabet(a.status, b.status),
            },
            {
                title: 'Բլոկավորված',
                dataIndex: 'isBlocked',
            },
            {
                title: '',
                dataIndex: 'edit',
                render: editing_user_data => (
                    <Link to={{
                        pathname: `/users/edit-user/${this.props.user_type}`,
                        state: { userData: editing_user_data } // This "carries" the full object to the next page
                    }}>
                        <button
                            type="button"
                            className="cust_btn color-green"
                        >
                            Խմբագրել
                        </button>
                    </Link>

                )
            }
        ];

        return (
            <>
                <Table pagination={paginationParams} columns={this.columns} dataSource={data}/>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        user_type: state.initReducer.user_type,
        market_id: state.initReducer.market_id,
        loading: state.usersReducer.loading,
        error_message: state.usersReducer.error_message,
        user_edited: state.usersReducer.user_edited,
        users_list: state.usersReducer.users_list,
        shops_list: state.usersReducer.shops_list,
        partners_list: state.usersReducer.partners_list,
        users_list_filter: state.usersReducer.filter,
    }
}

const TableFormContainer = Form.create()(TableContainer);

export default connect(mapStateToProps)(TableFormContainer);

